import { defineStyle } from "@chakra-ui/react";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { textStyles } from "../../../../theme/foundations/generated";
import { StatusVariant } from "../TagStatus.types";
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "container",
    "ellipse",
    "text",
]);
const baseStyle = {
    container: {
        display: "flex",
        gap: ".5rem",
        alignItems: "center",
        width: "fit-content",
        padding: ".25rem 0.5rem",
        background: "semantic.surface.1",
        border: "1px solid ",
    },
    text: Object.assign(Object.assign({}, textStyles.body.medium), { color: "semantic.text.primary" }),
    ellipse: {
        width: ".5rem",
        height: ".5rem",
        borderRadius: "50%",
    },
};
const variants = {
    created: defineStyle({
        container: {
            borderColor: "semantic.border.created",
        },
        ellipse: {
            background: "semantic.border.created",
        },
    }),
    inProgress: defineStyle({
        container: {
            borderColor: "semantic.border.inprogress",
        },
        ellipse: {
            background: "semantic.border.inprogress",
        },
    }),
    delay: defineStyle({
        container: {
            borderColor: "semantic.border.delay",
        },
        ellipse: {
            background: "semantic.border.delay",
        },
    }),
    shipped: defineStyle({
        container: {
            borderColor: "semantic.border.shipped",
        },
        ellipse: {
            background: "semantic.border.shipped",
        },
    }),
    canceled: defineStyle({
        container: {
            borderColor: "semantic.border.error",
        },
        ellipse: {
            background: "semantic.border.error",
        },
    }),
    expired: defineStyle({
        container: {
            borderColor: "semantic.border.primary",
        },
        ellipse: {
            background: "semantic.border.primary",
        },
        text: {
            color: "semantic.text.secondary",
        },
    }),
};
const TagStatusTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: StatusVariant.CREATED,
    },
});
export default TagStatusTheme;
//# sourceMappingURL=TagStatus.default.js.map